import { render, staticRenderFns } from "./AppCardCollapsable.vue?vue&type=template&id=db49b72c&scoped=true&"
import script from "./AppCardCollapsable.vue?vue&type=script&lang=js&"
export * from "./AppCardCollapsable.vue?vue&type=script&lang=js&"
import style0 from "./AppCardCollapsable.vue?vue&type=style&index=0&id=db49b72c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db49b72c",
  null
  
)

export default component.exports